import { Locales } from "@simplyk/common";

import { PrizeToTranslate } from "../PrizeTranslationSection";

import { TicketingOutput } from "@/common/types/trpc";

export const buildPrizesToTranslate = (
  prizes: TicketingOutput["prizes"],
  formLocale: Locales,
  translationLocale: Locales
): PrizeToTranslate[] =>
  (prizes ?? []).map((prize) => ({
    id: prize.id,
    value: prize.value,
    source: prize.prizeFields.find((field) => field.locale === formLocale),
    saved: prize.prizeFields.find((field) => field.locale === translationLocale),
  }));
